import React, { useEffect } from 'react'


const SuccessLoadForm: React.FC= () => {

  useEffect(()=>{
    document.title = 'Thank you'
    document.getElementsByTagName('body')[0]!.classList.add('thanks')

  }, [])

  return (
    <div className='success-loan-form-wrap'>
        <div className='success-loan-form-inside'>
            <header className="success-loan-form-inside-thtop">
                <div className="logo">
                <a href="/"><img src="/imgs/altlogo.png" alt="Elite Community Credit Union Logo" /></a>
                </div>
                <address className='success-loan-form-inside-address'>
                    <div className="street">515 S. Main Street Bourbonnais, IL 60914</div>
                    <div className="contact">Phone: (815) 933-7711 <span>•</span> Fax: (815) 933-5802</div>
                </address>
            </header>

            <div className="success-loan-form-inside-thcontent clear">
                <h1>Thank You!</h1>
                <p>
                Your <strong>Loan Application</strong> has been received.<br/>
                The Credit Union will get in touch with you within 1 business day.
                </p>

                <p><a href="/" className="success-loan-form-inside-homelink">Return to Home</a></p>
                
            </div>
        </div>
    </div>
  )
}

export default SuccessLoadForm